import conf from '../conf.js'

export function getStatus(status) {
  return conf.progessi.work_effort_item_status[status].text || null
}
